'use strict';

angular.module('licensure.services')
    .factory('IPCheckoutLogs', ['$http', '$q', function ($http, $q) {

        return {
            get: function () {
                var d = $q.defer();

                $http.get(apiLocation + '/api/IPCheckoutLogs', {
                    params: {
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/IPCheckoutLogs/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (checkout_log) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/IPCheckoutLogs/';
                if (!isUndefined(checkout_log.id)) {
                    method = 'PUT'
                    url += checkout_log.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        checkout_log: checkout_log
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        };
    }])
;